import axios from 'axios'
import axiosConfig from './modules/axiosConfig'
import PageHome from './pages/Home.js'
import PageProgramacao from './pages/Programacao.js'
import PageDsSections from './pages/ds_sections.js'
import PageLogin from './pages/Login'
import UseMouseOrKeyboard from './modules/UseMouseOrKeyboard'
import DesignSystem from './DesignSystem/DesignSystem'
import { register } from 'swiper/element/bundle'
import logs from './utils/logs'
import ripple from './modules/ripple'
import formErros from './modules/formErros'
import animaAoScroll from './animation/animaAoScroll'
import animateSetup from './animation/animateSetup'
import denunciaForm from './modules/contatoApi'
import shareUrl from './modules/sharedURL'

// import SvgUse from "./utils/SvgUse";

// Init
GLOBAL.DesignSystem = DesignSystem({})
register() // Swiper Web Component

// Config
axiosConfig({ csrf: GLOBAL.context?.csrf }, axios)
UseMouseOrKeyboard()
ripple()
formErros()
animateSetup()
animaAoScroll()
console.log('teste z2')

// Pages
PageHome()
PageProgramacao()
PageDsSections()
PageLogin()?.init()

// utils logs
logs()

denunciaForm()

shareUrl()


document.addEventListener('DOMContentLoaded', () =>{
	Fancybox.bind("[data-fancybox='fotos-album']", {
  Toolbar: {
    display: [
      { id: "prev", position: "center" },
      { id: "counter", position: "center" },
      { id: "next", position: "center" },
      "zoom",
      "fullscreen",
      "download",  // <-- botão de download
      "close"
    ]
  }
});
})


document.querySelectorAll(".share-btn-galeria").forEach((btn) => {
  btn.addEventListener("click", (event) => {
    event.stopPropagation(); // evita que o clique suba pro <a>
    event.preventDefault();  // evita ação do link, se necessário

    const url = btn.getAttribute("data-url");

    if (navigator.share) {
      navigator.share({
        title: "Olha essa foto!",
        url: url,
      });
    } else {
      navigator.clipboard.writeText(url);
      alert("Link copiado: " + url);
    }
  });
});

// Botão de download
// document.querySelectorAll(".download-img").forEach((btn) => {
//   btn.addEventListener("click", (event) => {
//     event.stopPropagation();
//     event.preventDefault();

//     const url = btn.closest(".single-foto-img").getAttribute("href");
   
//     // Cria link temporário para download
//     const a = document.createElement("a");
//     a.href = url; 
//     a.download = url.split("/").pop(); // nome do arquivo
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//   });
// });

document.querySelectorAll(".download-img").forEach((btn) => {
  btn.addEventListener("click", async (event) => {
    event.stopPropagation();
    event.preventDefault();

    const url = btn.closest(".single-foto-img").getAttribute("href");
    const filename = url.split("/").pop();

    try {
      const response = await fetch(url, { mode: "cors" }); // precisa permitir CORS
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Erro ao baixar a imagem:", err);
      alert("Não foi possível baixar a imagem. Verifique CORS no S3.");
    }
  });
});